import React from "react";
import Becomeanally1 from "../components/Becomeanally/Becomeanally1";
import AllyBenefits from "../components/Becomeanally/AllyBenefits";
import Becomeanally2 from "../components/Becomeanally/Becomeanally2";
import Joinvillage from "../components/landingpage/Joinvillage";

const Becomeanally = () => {
  return (
    <div className="w-full flex flex-col items-stretch">
      <Becomeanally1 />
      <AllyBenefits />
      <Becomeanally2 />
      <Joinvillage />
    </div>
  );
};

export default Becomeanally;
